import React from 'react';
import { Typography, Container, Button } from '@mui/material';

import './index.css';

const url = 'https://play.google.com/store/apps/details?id=com.saientric.ido&fbclid=IwAR2qi8e0un0fK4ufa7_RI8UvKnC_T6OXJF7cJWFWdyaKU8f0Q_cCtUx0650';


export default function TextComponent() {


  return (
    <>
      <Container fullWidth>
        <Container sx={{display: 'flex', flexDirection: 'column', justifyContent: 'center', backgroundColor: 'transparent', height: '100vh', padding: {xs: 5, sm: 5, md: 5, lg: 0, xl: 0}}}>
            <Typography variant="h3" sx={{fontWeight: '700', color: 'white', textShadow: '-5px -1px 4px rgba(19, 129, 162, 0.25), 0px 4px 4px rgba(137, 153, 168, 0.25)', fontSize: {xs: 80, sm: 80, md: 45, lg: 50, xl: 50}, marginTop: 15 }} >Ready to find your perfect match? I-Do!</Typography>
            <Typography paragraph sx={{marginTop: 2, fontSize: {xs: 40, sm: 40, md: 20, lg: 20, xl: 20}, color: 'white', opacity: 0.65}} >Gone are the days of being alone. With iDo, dating is at the tip of your fingers. Chat with someone who fits your interest. We will help you find your match and swipe right to forever. </Typography>
             <div>
                <a href='https://play.google.com/store/apps/details?id=com.saientric.ido&fbclid=IwAR2qi8e0un0fK4ufa7_RI8UvKnC_T6OXJF7cJWFWdyaKU8f0Q_cCtUx0650&pcampaignid=pcampaignidMKT-Other-global-all-co-prtnr-py-PartBadge-Mar2515-1'><img className='gPlay' alt='Get it on Google Play' src='https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png'/></a>
            </div>
        </Container>
      </Container>
        
       
    </>
  );
}
